import axios from 'src/utils/axios';

class AuthorityService {
  getAll = ({ page = 0, pageSize = 10 } = {}) =>
    new Promise((resolve, reject) => {
      axios
        .get('/api/administration/authorities', {
          params: {
            page,
            pageSize
          }
        })
        .then(response => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }
        })
        .catch(error => {
          reject(error);
        });
    });

  create = attributes =>
    new Promise((resolve, reject) => {
      axios
        .post('/api/administration/authorities', attributes)
        .then(response => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }
        })
        .catch(error => {
          reject(error);
        });
    });

  update = (id, attributes) =>
    new Promise((resolve, reject) => {
      axios
        .put(`/api/administration/authorities/${id}`, attributes)
        .then(response => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
}

export const authorityService = new AuthorityService();
